'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _countryList = require('country-list');

var _countryList2 = _interopRequireDefault(_countryList);

var _reactAutocomplete = require('react-autocomplete');

var _reactAutocomplete2 = _interopRequireDefault(_reactAutocomplete);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var countries = (0, _countryList2.default)().getData();

var CountriesComboBox = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(CountriesComboBox, _React$Component);

  function CountriesComboBox() {
    (0, _classCallCheck3.default)(this, CountriesComboBox);
    return (0, _possibleConstructorReturn3.default)(this, (CountriesComboBox.__proto__ || (0, _getPrototypeOf2.default)(CountriesComboBox)).apply(this, arguments));
  }

  (0, _createClass3.default)(CountriesComboBox, [{
    key: 'matchCountryToTerm',
    value: function matchCountryToTerm(country, value) {
      return country.name.toLowerCase().indexOf(value.toLowerCase()) !== -1 || country.code.toLowerCase().indexOf(value.toLowerCase()) !== -1;
    }
  }, {
    key: 'sortCountries',
    value: function sortCountries(a, b, value) {
      if (value.length) {
        return a.name.toLowerCase().indexOf(value.toLowerCase()) > b.name.toLowerCase().indexOf(value.toLowerCase()) ? 1 : -1;
      } else {
        return a.name > b.name ? 1 : -1;
      }
    }
  }, {
    key: 'renderCountry',
    value: function renderCountry(item, isHighlighted) {
      var _classnames;

      var styles = require('./CountriesComboBox.scss');

      var itemClassName = (0, _classnames3.default)((_classnames = {}, (0, _defineProperty3.default)(_classnames, styles.CountriesComboBox__item, true), (0, _defineProperty3.default)(_classnames, styles['CountriesComboBox__item--highlighted'], isHighlighted), _classnames));

      return _react2.default.createElement(
        'div',
        {
          className: itemClassName,
          key: item.code
        },
        item.name
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./CountriesComboBox.scss');

      var matchCountryToTerm = this.matchCountryToTerm,
          sortCountries = this.sortCountries,
          renderCountry = this.renderCountry;
      var _props = this.props,
          initialValue = _props.initialValue,
          label = _props.label,
          disabled = _props.disabled,
          onSelect = _props.onSelect,
          onChange = _props.onChange;


      var inputProps = (0, _extends3.default)({}, this.props.inputProps, {
        disabled: disabled,
        className: styles.CountriesComboBox__inputField
      });

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'label',
          null,
          _react2.default.createElement(
            'div',
            null,
            label
          ),
          _react2.default.createElement(_reactAutocomplete2.default, {
            items: countries,
            getItemValue: function getItemValue(item) {
              return item.name;
            },
            shouldItemRender: matchCountryToTerm,
            sortItems: sortCountries,
            renderItem: renderCountry,
            inputProps: inputProps,
            onSelect: onSelect,
            onChange: onChange,
            initialValue: initialValue,
            menuStyle: {
              borderRadius: '3px',
              boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
              background: 'rgba(255, 255, 255, 0.9)',
              padding: '2px 0',
              fontSize: '90%',
              position: 'fixed',
              overflow: 'auto',
              left: 'auto',
              top: 'auto',
              maxHeight: '50%' // TODO: don't cheat, let it flow to the bottom
            }
          })
        )
      );
    }
  }]);
  return CountriesComboBox;
}(_react2.default.Component), _class.propTypes = {
  initialValue: _react2.default.PropTypes.any,
  label: _react2.default.PropTypes.string,
  inputProps: _react2.default.PropTypes.string,
  onSelect: _react2.default.PropTypes.func,
  disabled: _react2.default.PropTypes.bool,
  onChange: _react2.default.PropTypes.func
}, _class.defaultProps = {
  inputProps: {},
  onSelect: function onSelect() {},
  onChange: function onChange() {}
}, _temp);
exports.default = CountriesComboBox;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/CountriesComboBox/CountriesComboBox.jsx
// module id = 2611
// module chunks = 0